import lottie from 'lottie-web/build/player/lottie_light'
import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class LottieComponent extends Component {
    static selector () {
        return '[data-lottie-path]'
    }

    constructor (opts) {
        super(opts)

        if (!this.getPath())
            return

        lottie.setQuality('low')

        this.props.playing = false
        this.props.ready = false

        this.animation = lottie.loadAnimation({
            container: this.el,
            renderer: 'svg',
            path: this.getPath(),
            loop: this.isLoop(),
            autoplay: false,
            rendererSettings: {
                progressiveLoad: true
            }
        })

        this.render()
        this.listen()
    }

    listen () {
        RootComponent.Scroller.state
            .on('update', this.render.bind(this))

        this.on('resize', this.render.bind(this))
    }

    onDestroy () {
        RootComponent.Scroller.state
            .off('update', this.render.bind(this))

        this.off('resize', this.render.bind(this))

        if (this.animation)
            this.animation.destroy()
    }

    onPlay () {
        if (this.props.playing === 'true'
                || this.props.ready !== 'true')
            return

        this.props.playing = true
        this.animation.play()

        if (!this.isLoop())
            this.animation
                .addEventListener('complete', () => {
                    this.props.lottieComplete = true
                })

        if (!this.isLoop())
            RootComponent.Scroller.state
                .off('update', this.render.bind(this))
    }

    onPause () {
        if (this.props.playing !== 'true'
                || !this.isLoop())
            return

        this.props.playing = false
        this.animation.pause()
    }

    isLoop () {
        return this.el.getAttribute('data-lottie-loop') !== 'false'
    }

    isVisible () {
        const bounds = this.el.getBoundingClientRect()
        const bottom = bounds.top + bounds.height

        return (bounds.top >= 0 && bottom < window.innerHeight)
            || (bounds.top >= 0 && bounds.top < window.innerHeight)
            || (bottom >= 0 && bottom < window.innerHeight)
    }

    getPath () {
        return this.el.getAttribute('data-lottie-path')
    }

    render () {
        if (!document.body.contains(this.el))
            return this.onDestroy()

        if (this.props.ready !== 'true'
                && this.props.lottieDelay) {
            if (!this.isVisible()
                    || (this.props.delayComplete
                        && this.props.delayComplete !== 'true'))
                return

            this.props.delayComplete = false

            return setTimeout(() => {
                this.props.ready = true
                this.props.delayComplete = true
                this.onPlay()
            }, Number(this.props.lottieDelay) || 0)
        }

        this.props.ready = true

        return this.isVisible()
            ? this.onPlay()
            : this.onPause()
    }
}
